import { Role } from '../../store/contextAPI/role/dto/response/role.dto';

export const getInitiativeNames = (
  names?: string[],
  roles?: Role[]
): string => {
  if (roles?.some((role) => role.name === 'Admin')) {
    return 'All landscapes';
  }
  return names?.length ? names.join(', ') : '';
};
